<template>
  <div class="layout-form">
    <joi-form :data="data" :schema="validationSchema" :error="formError" v-on:formdataready="save">
      <div class="row">
        <div class="small-4 columns small-centered">
          <span data-form-error-callout></span>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Megnevezés:
            <input type="text" name="title" v-model="data.title">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label error-path="channels">
            Oldalak:
            <channel-selector v-model="data.channels"></channel-selector>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Posztok forrása:
          </label>
          <input id="postSource-pageFeedPosts" type="radio" value="pageFeedPosts" v-model="data.postSource"><label for="postSource-pageFeedPosts">Hírfolyamposztok</label>
          <input id="postSource-pagePublishedPosts" type="radio" value="pagePublishedPosts" v-model="data.postSource"><label for="postSource-pagePublishedPosts">Publikált posztok</label>
          <span error-path="postSource"></span>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Vizsgált időszak:
            <date-picker v-model="data.interval" mode="range" error-path="interval"></date-picker>
            <span error-path="interval.min"></span>
            <span error-path="interval.max"></span>
          </label>
        </div>
      </div>
      <div class="row expanded bottom">
        <div class="small-4 columns">
          <button type="submit" class="button primary trans-uppercase">Mentés</button>
          <button type="button" class="button alert trans-uppercase" v-if="data.id" @click="remove">Törlés</button>
          <button type="button" class="button secondary trans-uppercase" @click="back">Vissza</button>
        </div>
      </div>
    </joi-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import moment from 'moment'
import * as mutationTypes from '../../store/mutation-types'
import JoiForm from '../../inputs/joi-form'
import ChannelSelector from '../../inputs/channel-selector'
import DatePicker from '../../inputs/date-picker'
import {editAnalytics as validationSchema} from '../../../schemas'
import analyticsService from '../../services/analytics'
import Confirm from '../../mixins/Confirm'

export default {
  name: 'analytics-edit',
  mixins: [Confirm],
  components: {
    JoiForm,
    ChannelSelector,
    DatePicker
  },
  data () {
    return {
      data: {
        id: undefined,
        title: undefined,
        channels: [],
        postSource: undefined,
        interval: undefined
      },
      validationSchema,
      formError: null,
      existingUser: false
    }
  },
  created: function () {
    if (this.$route.params.id) {
      this.load(this.$route.params.id)
    }
  },
  watch: {
    '$route': function (newVal, oldVal) {
      if (newVal.params.id) {
        this.load(newVal.params.id)
      }
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    onAddNewItem () {
      this.$router.push('analytics/edit')
    },
    back () {
      this.$router.push({name: 'analytics-list'})
    },
    load (id) {
      this.reset()
      this[mutationTypes.BUSY_ON]()
      analyticsService.load(id).then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.data = data
        this.existingUser = Boolean(data.masterEmail)
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    reset () {
    },
    save (formData) {
      formData.intervalStart = moment(this.data.interval.min).startOf('day').format()
      formData.intervalEnd = moment(this.data.interval.max).endOf('day').format()
      formData.immediate = true
      this[mutationTypes.BUSY_ON]()
      analyticsService.save(this.data.id, formData).then((result) => {
        this[mutationTypes.BUSY_OFF]()
        this.back()
      }).catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.formError = err
      })
    },
    remove () {
      this.confirm('Törlés', 'Biztos vagy benne?').then((confirmed) => {
        if (confirmed) {
          this[mutationTypes.BUSY_ON]()
          analyticsService.remove(this.data.id).then((result) => {
            this[mutationTypes.BUSY_OFF]()
            this.back()
          }).catch((err) => {
            this[mutationTypes.BUSY_OFF]()
            this.formError = err
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/form';
</style>



// WEBPACK FOOTER //
// Edit.vue?38df829a